export const publicationUK = state => state.publication.publicationUK;
export const publicationRU = state => state.publication.publicationRU;
export const publicationErrorUK = state => state.publication.publicationErrorUK;
export const publicationErrorRU = state => state.publication.publicationErrorRU;
export const publicationLoading = state => state.publication.loading;
